import { ROUTE } from "../../../routes";
import { WIDGET } from "@voltmoney/schema";
export const continueAction = async (action, _datastore, { navigateWithClear, setDatastore, removeWidgets }) => {
    const netPayable = action?.payload?.netPayable;
    const extraOutstandingBufferBajaj = action?.payload?.extraOutstandingBufferBajaj;
    const extraOutstandingBufferDsp = action?.payload?.extraOutstandingBufferDsp;
    await setDatastore(ROUTE.VIEW_PORTFOLIO_DETAIL, 'manageLimit', {
        bankData: []
    });
    await removeWidgets(ROUTE.VIEW_PORTFOLIO_DETAIL, [
        { id: "manageLimit", type: WIDGET.VIEW_PORTFOLIO }
    ]);
    navigateWithClear(ROUTE.UNPLDEGE_FUNDS, { netPayable, extraOutstandingBufferBajaj, extraOutstandingBufferDsp });
};
export const goBackAction = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.VIEW_PORTFOLIO_DETAIL);
};
export const needHelpAction = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.CONTACT_US_CARD);
};
